<template>
    <div class="row pl-3 pr-3">
        <div class="col-12">
            <div class="row border rounded pt-2 pb-2 summary--section" :class="classes" v-show="showComputations">
                <div class="col-12">
                    <div class="row">
                        <div class="col-8 text-uppercase"><span class="font-weight-bold" v-html="TEXTS.render(`BOOKING_SUMMARY_TOTAL_AMMOUNT`)"></span></div>
                        <div class="col-4 text-right font-weight-bold skiptranslate">${{ getTotalAmount}}</div>
                    </div>
                </div>
            </div>

            <!-- 
                Stry: PSUS425 - As a user, I want to see the summary of collections for my paid multiple collection booking
                Date: 2020-11-25
                Auth: Franco Mapua
                Desc: This is the display for the computed entitlements
             -->
            <div v-if="isDisplayCollectionSummary" class="row border rounded pt-2 pb-2 summary--section mt-2" :class="classes">
                <div class="col-12">
                    <div class="row">
                        <div class="col-8 text-uppercase"><span class="font-weight-bold" v-html="TEXTS.render(`BOOKING_SUMMARY_TOTAL_COLLECTIONS`)"></span></div>
                        <div class="col-4 text-right font-weight-bold skiptranslate">{{ totalCollections != -1 ? totalCollections : "..." }}</div>
                    </div>
                    <div class="row">
                        <div class="col-8 text-uppercase"><span class="font-weight-bold" v-html="TEXTS.render(`BOOKING_SUMMARY_ENTITLED_COLLECTIONS`)"></span></div>
                        <div class="col-4 text-right font-weight-bold skiptranslate">{{ entitledCollections != -1 ? entitledCollections : '' }}</div>
                    </div>
                </div>
            </div>
            <div v-if="isDisplayCollectionSummary && isDisplayError" class="row mt-3 font-weight-bold text-danger" v-html="TEXTS.render(`BOOKING_SUMMARY_COLLECTIONS_ERROR`)"></div>
        </div>
    </div>
</template>

<script>
    import Texts from '../../../../common/utils/Texts'
    import DateNoTz from '../../../../common/utils/DateNoTz'
    import BookingSummaryMixin from '../../../../common/mixins/BookingSummaryMixin';
    import IsDisplayCollectionSummaryMixin from '../../../../common/mixins/IsDisplayCollectionSummaryMixin';

    export default {
        mixins: [BookingSummaryMixin, IsDisplayCollectionSummaryMixin],
        props: [
            'classes'
        ],
        data() {
            return {
                entitledCollections: -1
            }
        },
        computed: {
            TEXTS : ()=> Texts,
            bookingState(){
                return this.$store.getters.GET_BOOKING_STATE;
            },
            getTotalAmount() {
                return this.$store.getters.GET_BOOKING_SUMMARY_DETAILS.totalAmount;
            },
            selectedEntitlementGroup(){
                var selectedService = this.$store.getters.GET_BOOKING_STATE.selectedService || {};
                var entitlementSettingId = selectedService.entitlement_setting_id
                var entitlementGroupSettings  = this.$store.getters.GET_ENTITLEMENT_GROUP.list;
                if(!entitlementSettingId || !Array.isArray(entitlementGroupSettings)){
                    return null
                }

                return entitlementGroupSettings.find(settings => settings.entitlement_setting_id == entitlementSettingId)
            },
            activeMultipleCollectionSetting(){
                return this.$store.getters.GET_ACTIVE_MULTIPLE_COLLECTION_SETTING
            },
            entitlementSummary() {
                var bookingState = this.bookingState
                return bookingState.entitlementSummary || {}
            },
            collectionData(){
                const collectionData = this.bookingState.collectionData || {};
                return collectionData
            },
            totalCollections() {
                
                var bookingState = this.bookingState
                if(this.activeMultipleCollectionSetting && this.activeMultipleCollectionSetting.per_waste_collection == 1 && Array.isArray(this.selectedBookingProducts)){
                    /*
                        Stry: [US460] As a user, I want to book a per waste - collection service
                        Date: 2021-02-19
                        Auth: Franco Mapua
                        Desc: Making the TOtal Collection the sum of product qtys
                    */
                    var sum = 0
                    this.selectedBookingProducts.forEach(product => {
                        sum += !product.isFake ? product.qty : 0
                    })
                    return sum
                }
                else{
                    return Array.isArray(this.selectedBookingProducts) && this.selectedBookingProducts.length >= 1 && bookingState.computedEntitlement ? bookingState.computedEntitlement : 0
                }
            },
            selectedBookingProducts(){
                var bookingState = this.bookingState
                return bookingState.selectedBookingProducts || null
            },
            displayErrorEntitled(){
                var totalCollections = this.totalCollections || 0
                var entitledCollections = this.entitledCollections || 0

                if(totalCollections > entitledCollections && entitledCollections != -1){
                    this.bookingState.hasErrorInSummarySecThree = true;
                }else{
                    this.bookingState.hasErrorInSummarySecThree = false;
                }
                
                return this.bookingState.hasErrorInSummarySecThree;
            },
            isDisplayError() {
                var totalCollections = this.totalCollections || 0
                var entitledCollections = this.entitledCollections || 0

                return entitledCollections > -1 && totalCollections > entitledCollections
            },
        },
        methods: {
            computeEntitlements() {
                // --- Determine Entilement Usage Type
                var entitledCollections = -1
                if(this.selectedEntitlementGroup && this.entitlementSummary && this.isDisplayCollectionSummary && Array.isArray(this.selectedBookingProducts) && this.selectedBookingProducts.length >= 1 ){ 
                    // --- Check for Entitlement Usage
                    // --- get entitlement summary
                    var entitlementUsageType = this.selectedEntitlementGroup.entitlement_usage
                    var entitlementSummary = this.entitlementSummary

                    var currentPeriod = entitlementSummary.currentPeriod || {}
                    var nextPeriod = entitlementSummary.nextPeriod || {}

                    var activePeriod = null
                    if(entitlementUsageType == 1 && this.collectionData && this.collectionData.periodType && this.collectionData.selectedPeriod){ // --- Collection Date
                        var { periodType, selectedPeriod } = this.collectionData;

                        // -- Determine which period to use
                        var dateToCheck = null;
                        if (periodType.indexOf("week") > -1 && selectedPeriod) {
                            // --- Get Default Collection Date of that week
                            var differenceInTime =
                            (selectedPeriod.end - selectedPeriod.start) / (1000 * 60 * 60 * 24);
                            var defaultCollectionDay =
                            this.selectedService.default_collection_day || 0;

                            // --- Scan for the next DefaultCollectionDay
                            var cursorDate = new Date(selectedPeriod.start);
                            for (let i = 0; i < differenceInTime + 2; i++) {
                            if (cursorDate.getDay() == defaultCollectionDay) {
                                dateToCheck = cursorDate;
                                break;
                            } else {
                                cursorDate.setDate(cursorDate.getDate() + 1);
                            }
                            }
                            cursorDate = cursorDate || new Date(selectedPeriod.start);
                        } else {
                            dateToCheck = selectedPeriod;
                        }

                        dateToCheck = new DateNoTz(dateToCheck).convertToSeconds();
                        // --- Find Period of dateToCheck
                        var periods = [
                            currentPeriod,
                            nextPeriod,
                        ];
                        var matchedPeriod = periods.find((period) => {
                            var periodStart = new DateNoTz(period.startDate).convertToSeconds();
                            var periodEnd = new DateNoTz(period.endDate).convertToSeconds();
                            return periodStart <= dateToCheck && dateToCheck <= periodEnd;
                        });

                        activePeriod = matchedPeriod
                    }
                    else if(entitlementUsageType == 2){ // --- Booking Date
                        activePeriod = currentPeriod
                    }

                    if(activePeriod){
                        entitledCollections = activePeriod.entitlementsRemaining[this.selectedEntitlementGroup.entitlement_setting_id]
                    }
                }

                this.entitledCollections = entitledCollections
            }
        },
        watch: {
            selectedBookingProducts(newValue, oldValue) {
                this.computeEntitlements()
            },
            collectionData(newValue, oldValue) {
                this.computeEntitlements()
            },
            displayErrorEntitled(newValue, oldValue) {
                this.computeEntitlements()
            },
        },
    }
</script>